export default "__VITE_ASSET__CcC$5H2A__"